import { QuotaTypes } from 'client/Interfaces/Subscription'
import * as React from 'react'

import './FeatureList.scss'
import InvoiceQuotaMultiplePlanSelect from './InvoiceQuotaMultiplePlanSelect'
import QuotaAmount from './QuotaAmount'

const InvoiceQuota = (props) => {
  const {
    selectedPlanName,
    isCombinedPlan,
    onSelectCombinedPlan,
    selectableAvailablePlans,
    feature,
    billingCycle,
    allPlans,
    processingPlanName,
  } = props

  if (isCombinedPlan && feature.id === QuotaTypes.INVOICE) {
    return (
      <InvoiceQuotaMultiplePlanSelect
        billingCycle={billingCycle}
        selectedPlanName={selectedPlanName}
        onSelectCombinedPlan={onSelectCombinedPlan}
        selectableAvailablePlans={selectableAvailablePlans}
        allPlans={allPlans}
      />
    )
  }

  return (
    <QuotaAmount
      feature={feature}
      billingCycle={billingCycle}
      allPlans={allPlans}
      processingPlanName={processingPlanName}
    />
  )
}

export default InvoiceQuota
